import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useNotifications } from '../../contexts/NotificationContext';
import { validateForm, validationRules } from '../../utils/validation';
import { loginThunk } from '../../features/auth/authThunks';
import './Login.scss';
const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login, isLoading, user } = useAuth();
    const { success, error } = useNotifications();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: false,
    });
    const [validationErrors, setValidationErrors] = useState({});
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
        // Clear validation error when user starts typing
        if (validationErrors[name]) {
            setValidationErrors(prev => ({
                ...prev,
                [name]: '',
            }));
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate form
        const errors = validateForm(formData, validationRules.login);
        setValidationErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        try {
            const result = await login(formData.email, formData.password);
            // Check if login was successful using Redux Toolkit's action matching
            if (loginThunk.fulfilled.match(result)) {
                const userData = result.payload.user;
                success('Login realizado com sucesso!', `Bem-vindo de volta, ${userData.name}!`);
                console.log('✅ Login successful:', {
                    user: userData.name,
                    role: userData.role,
                    plan: userData.plan?.name,
                    features: userData.features
                });
                // Redirecionamento simples - sempre para home (/)
                const intendedPath = location.state?.from?.pathname;
                const redirectPath = (intendedPath && intendedPath !== '/login') ? intendedPath : '/';
                console.log(`🔄 Redirecting to: ${redirectPath}`);
                navigate(redirectPath, { replace: true });
            }
            else {
                // Login failed
                const errorMessage = result.payload || 'Credenciais inválidas. Tente novamente.';
                error('Erro no login', errorMessage);
            }
        }
        catch (err) {
            error('Erro no login', 'Ocorreu um erro inesperado. Tente novamente.');
            console.error('❌ Login failed:', err);
        }
    };
    const getFieldError = (fieldName) => {
        return validationErrors[fieldName] || '';
    };
    const hasFieldError = (fieldName) => {
        return !!validationErrors[fieldName];
    };
    return (_jsx("div", { className: "login-page", children: _jsx("div", { className: "container", children: _jsx("div", { className: "row justify-content-center align-items-center min-vh-100", children: _jsx("div", { className: "col-md-6 col-lg-4", children: _jsx("div", { className: "card login-card", children: _jsxs("div", { className: "card-body p-4", children: [_jsxs("div", { className: "text-center mb-4", children: [_jsx("h2", { className: "login-title", children: "Bem-vindo de volta" }), _jsx("p", { className: "text-muted", children: "Entre na sua conta" })] }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("div", { className: "mb-3", children: [_jsx("label", { htmlFor: "email", className: "form-label", children: "Email" }), _jsx("input", { type: "email", className: `form-control ${hasFieldError('email') ? 'is-invalid' : ''}`, id: "email", name: "email", value: formData.email, onChange: handleInputChange, placeholder: "Digite seu email", disabled: isLoading }), hasFieldError('email') && (_jsx("div", { className: "invalid-feedback", children: getFieldError('email') }))] }), _jsxs("div", { className: "mb-3", children: [_jsx("label", { htmlFor: "password", className: "form-label", children: "Senha" }), _jsx("input", { type: "password", className: `form-control ${hasFieldError('password') ? 'is-invalid' : ''}`, id: "password", name: "password", value: formData.password, onChange: handleInputChange, placeholder: "Digite sua senha", disabled: isLoading }), hasFieldError('password') && (_jsx("div", { className: "invalid-feedback", children: getFieldError('password') }))] }), _jsxs("div", { className: "mb-3 form-check", children: [_jsx("input", { type: "checkbox", className: "form-check-input", id: "rememberMe", name: "rememberMe", checked: formData.rememberMe, onChange: handleInputChange, disabled: isLoading }), _jsx("label", { className: "form-check-label", htmlFor: "rememberMe", children: "Lembrar de mim" })] }), _jsx("button", { type: "submit", className: "btn btn-primary w-100", disabled: isLoading, children: isLoading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status", "aria-hidden": "true" }), "Entrando..."] })) : ('Entrar') })] }), _jsx("div", { className: "text-center mt-3", children: _jsxs("p", { className: "mb-0", children: ["N\u00E3o tem uma conta?", ' ', _jsx(Link, { to: "/register", className: "text-decoration-none", children: "Registre-se" })] }) })] }) }) }) }) }) }));
};
export default Login;
